







































































































































import { vxm } from '../store.vuex';
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { AuthParams } from '@/models/userdata/authparams';
import VueRecaptcha from 'vue-recaptcha';
import { Frictionless } from '../models/referrals/frictionless';
import { ReferralPayload } from '../models/referrals/referralPayload';
import { ReferralSuccess } from '../models/referrals/referralSuccess';
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
import { GoogleContactResponse } from '../models/socialmedia/googlecontactresponse';
import { WLGoogleContact } from '../models/socialmedia/wlgooglecontact';
import Paginate from 'vuejs-paginate';
import VueClipboards from 'vue-clipboards';
import Jobseeker from './Jobseeker.vue';
import Myreferrals from './Myreferrals.vue';
import GoogleContactList from './GoogleContactList.vue';
import { CommonUserInfo } from '../models/referrals/commonuserinfo';
import UserForm from './ReferAFriend/UserForm.vue';
import { RecruiterResponse } from '../models/referrals/recruiterresponse';
import { Recruiter } from '../models/referrals/recruiter';
import { RecruiterRequest } from '../models/referrals/recruiterrequest';
import { ModelListSelect } from 'vue-search-select';
import SubmitButton from './ReferAFriend/SubmitButton.vue';
import MailClientOpener from '@/components/ReferAFriend/mailClientOpener';
import { ReferFriendRequest } from '../models/referrals/referfriendreqest';
import UserFormValidator from './ReferAFriend/userFormValidator';
import { mixins } from 'vue-class-component';
import { Referral } from '@/models/referrals/referral';
import RecruiterListUtility from './ReferAFriend/recruiterListUtility';
Vue.use(VueClipboards);
declare var window: any;

Vue.component('paginate', Paginate);

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 3000,
});

@Component({
  name: 'Invite',
  components: {
    Jobseeker,
    Myreferrals,
    GoogleContactList,
    ModelListSelect,
    UserForm,
    SubmitButton,
    UserFormValidator,
    MailClientOpener,
  },
})
export default class Invite extends mixins(
  UserFormValidator,
  MailClientOpener,
  RecruiterListUtility
) {
  scrollbar: boolean = true;
  $wlToastr: any;
  private frictionLess: Frictionless = new Frictionless();
  private referralSuccess: ReferralSuccess = new ReferralSuccess();
  private errorString: string = '';
  private googleContactResponse: GoogleContactResponse = new GoogleContactResponse();
  private selectedGoogleContacts: WLGoogleContact[] = [];
  private currentPage: number = 1;
  private recsPerPage: number = 5;
  private jobName: string = '';
  private searchContact: string = '';
  private jobDetailsViewLink: string = '';
  private friendInfo: CommonUserInfo = new CommonUserInfo();
  private recruiterResponse: RecruiterResponse = new RecruiterResponse();
  private recruiterRequest: RecruiterRequest = new RecruiterRequest();
  private referFriendRequest: ReferFriendRequest = new ReferFriendRequest();
  private recruiter: Recruiter = new Recruiter();

  updateSearchContact(value) {
    this.searchContact = value;
  }
  get hasGoogleContactImportConfigured() {
    if (window.WorkLLama.isConfigJSONEnabled === 'true') {
      return !vxm.configs.SocialLoginConfig.TURN_OFF_GOOGLE_CONTACTS
    }
    if (vxm.jobs.BrandingInfo.TURN_OFF_GOOGLE_CONTACTS) {
      return false;
    }
    return vxm.jobs.BrandingInfo.GOOGLE_CLIENT_ID;
  }
  get canShowGoogleContacts() {
    return (
      vxm.referrals.GoogleContactResponse.contacts &&
      vxm.referrals.GoogleContactResponse.contacts.length > 0
    );
  }
  get supportedFileSize() {
    return vxm.utility.fileUploadMaxSize;
  }
  sendJobReferralRequest() {
    let validationMessage;
    validationMessage = this.formValidator(this.friendInfo);
    if (validationMessage) {
      return this.$wlToastr('error', validationMessage, this.$t('myreferrals.jobreferral'));
    }
    if(this.friendInfo.mobile==null && this.friendInfo.phoneNumber.length>0){
      this.friendInfo.phoneNumber = ''
    }
    this.referFriendRequest.friendList.push(this.friendInfo);

    this.setCommonUserInfoData();

    this.referFriendRequest.commonUserInfo.recruiterName = this.recruiter.recruiterName;
    this.referFriendRequest.commonUserInfo.recruiterEmail = this.recruiter.recruiterEmail;
    this.referFriendRequest.companyCode =
      vxm.jobs.BrandingInfo.companycode || '';

    this.referFriendRequest.referralType = this.isJobSelected ? '02' : '01';
    if (this.isJobSelected) {
      this.referFriendRequest.jobPostingId = vxm.referrals.jobId
        ? vxm.referrals.jobId
        : 0;
    }
    this.referFriendRequest.referralCode = this.frictionLess.referralCode;
    console.log(' referFriendRequest payload ');
    vxm.users.Rudderstack.trackEvent("Job Referral", {
      jobPostingId: vxm.referrals.jobId,
      referralType: "Job Referral",
      recruiterId : this.recruiter.recruiterId
    })
    console.log(this.referFriendRequest);

    
    if (this.friendInfo.resumeFile && this.friendInfo.resumeFile.size > this.supportedFileSize) {
      this.$wlToastr(
        'error',
        this.$t('ResumeDetails_SizeRestriction', {maxSize: this.supportedFileSize / (1024 * 1024) }),
        this.$t('ResumeDetails_UploadResume'),
      );
      return;
    }
    
    const payload = new FormData()
    const jobReferralRequest = JSON.stringify(this.referFriendRequest)
    payload.append('jobReferralRequest', jobReferralRequest)

    this.friendInfo.resumeFile && payload.append('resumeFile', this.friendInfo.resumeFile)

    vxm.referrals
      .postFrictionlessNewReferral(payload)
      .then(() => {
        if (!vxm.referrals.EmployeeReferralResponse.success) {
          this.$wlToastr(
            'error',
            vxm.referrals.EmployeeReferralResponse.errorMessage,
            '',
          );
          this.referFriendRequest.friendList = [];
        } else {
          this.$wlToastr(
            'success',
             this.$t(
                  'referafriend.form.submit.success.message.without.bonus',
                ),
            '',
          );
         
          this.mailClientOpener(this.friendInfo.email);
          
          this.friendInfo = new CommonUserInfo();
          this.referFriendRequest = new ReferFriendRequest();
          this.recruiter = new Recruiter();
          this.recruiterResponse = new RecruiterResponse();
        }
      });
  }

  get isAutomateEmails(){
  return vxm.configs.getGlobalConfigValue('WL_AUTOMATE_REFERRAL_EMAILS');
}
  setCommonUserInfoData() {
    this.referFriendRequest.commonUserInfo.userId =
      vxm.users.myUserProfile.userId;
    this.referFriendRequest.commonUserInfo.firstName =
      vxm.users.myUserProfile.firstName;
    this.referFriendRequest.commonUserInfo.lastName =
      vxm.users.myUserProfile.lastName;
    this.referFriendRequest.commonUserInfo.email =
      vxm.users.myUserProfile.email;
    this.referFriendRequest.commonUserInfo.phoneNumber =
      vxm.users.myUserProfile.phoneNum + '';

    if (!vxm.users.isLoggedIn) {
      let referredUserData: Referral = vxm.referrals.getReferredUserData;
      this.referFriendRequest.commonUserInfo.email =
        referredUserData && referredUserData.email
          ? referredUserData.email
          : '';
      this.referFriendRequest.commonUserInfo.phoneNumber =
        referredUserData && referredUserData.phoneNbr
          ? referredUserData.phoneNbr
          : '';
    }
  }

  get canShowReferralBonusMessage() {
    return !vxm.configs.getGlobalConfigBooelanValue('DISABLE_REFERRAL_BONUS_INFO_IN_REFERRAL_PAGE')
  }

  get GoogleContacts(): WLGoogleContact[] {
    if (
      vxm.referrals.GoogleContactResponse.contacts &&
      vxm.referrals.GoogleContactResponse.contacts.length > 0
    ) {
      console.log(
        vxm.referrals.GoogleContactResponse.contacts,
        'GoogleContactResponse.contacts***',
      );
      this.googleContactResponse.contacts =
        vxm.referrals.GoogleContactResponse.contacts;
    }
    if (
      vxm.referrals.GoogleContactResponse.contacts &&
      vxm.referrals.GoogleContactResponse.contacts.length > 0
    ) {
      const start = this.currentPage * this.recsPerPage - this.recsPerPage;
      const end = this.currentPage * this.recsPerPage - 1;
      return vxm.referrals.GoogleContactResponse.contacts.filter((s, idx) => {
        return idx >= start && idx <= end;
      });
    } else {
      return [];
    }
  }

  printSearchText(searchText: string) {
    this.recruiterRequest.searchString = searchText;
    this.recruiterRequest.company = vxm.jobs.BrandingInfo.companycode;
    if (searchText.trim().length >= 3) {
      this.recruiterRequest.pageNumber = 1;
      this.recruiterRequest.pageSize = 5;

      if (vxm.users.isLoggedIn) {
        const respPromise: any = vxm.referrals
          .getRecruiterListByCompany(this.recruiterRequest)
          .then((values) => {
            if (vxm.referrals.RecruiterResponse.recruiterList !== null) {
              this.recruiterResponse = vxm.referrals.RecruiterResponse;
            }
          });
      } else {
        vxm.referrals
          .getAnonRecruiterListByCompany(this.recruiterRequest)
          .then(() => {
            if (vxm.referrals.RecruiterResponse.recruiterList !== null) {
              this.recruiterResponse = vxm.referrals.RecruiterResponse;
            }
          });
      }
    }
  }

  gotoDetailsPage(referralUrl) {
    this.$router.push({
      name: 'referral',
      params: { referralCode: this.referralSuccess.referralCode },
    });
  }

  clickCallback(page) {
    this.currentPage = page;
  }

  get selectedJobName() {
    let jobLocation = vxm.referrals.getReferral;
    return vxm.referrals.getRefferedJob;
  }

  get isJobSelected() {
    return vxm.referrals.getRefferedJob;
  }

  @Watch('selectedJobName')
  onPropertyChanged(value: string, oldValue: string) {
    console.log(value, '**New Valuew');
    this.jobName = value;
  }

  toggleContact(gc: WLGoogleContact) {
    const idx = this.selectedGoogleContacts.findIndex((i) => {
      return i.fullName === gc.fullName && i.email === gc.email;
    });
    if (idx === -1) {
      const ngc = new WLGoogleContact();
      ngc.email = gc.email;
      ngc.fullName = gc.fullName;
      this.selectedGoogleContacts.push(ngc);
    } else {
      this.selectedGoogleContacts.splice(idx, 1);
    }
  }

  // get pageCount() {
  //   if (vxm.referrals.GoogleContactResponse.contacts) {
  //     return Math.ceil(
  //       vxm.referrals.GoogleContactResponse.contacts.length / this.recsPerPage
  //     );
  //   } else {
  //     return Math.ceil(0 / this.recsPerPage);
  //   }
  // }

  googleLogin() {
    this.setOAuthProvider('google_contacts');
    return vxm.users.loginWithGoogle();
  }

  facebookLogin() {
    this.setOAuthProvider('facebook_post');
    return vxm.users.loginWithFacebook();
  }

  tweetJobReferralLink(url: string) {
    window.open(
      'https://twitter.com/share?url=' + encodeURIComponent(url + '?utm_source=x_share&utm_campaign=tp&utm_medium=referral')+'',
      'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600',
    );
    return false;
  }

  fbshareCurrentPage(url: string) {
    window.open(
      'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent( url +'?utm_source=fb_share&utm_campaign=tp&utm_medium=referral')+'',
      'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600',
    );
    return false;
  }

  linkedinshareJobReferralUrl(url: string) {
    window.open(
      'https://www.linkedin.com/shareArticle?mini=true&url=' + encodeURIComponent(url+'?utm_source=linkedin_share&utm_campaign=tp&utm_medium=referral') + '&title=',
      '',
      'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600',
    );
    return false;
  }

  googleContacts() {
    this.setOAuthProvider('google_contacts');
    return vxm.users.loginWithGoogle();
  }

  facebookPost() {
    this.setOAuthProvider('facebook_post');
    return vxm.users.loginWithFacebook();
  }

  setOAuthProvider(provider: string) {
    this.$cookies.set('OAuthProvider', provider, 300);
  }

  mounted() {
    const rSuccess = Vue.cookies.get('referralSuccess');
    const fLess = Vue.cookies.get('frictionLess');
    if (rSuccess && fLess) {
      this.referralSuccess.referralUrl = this.$cookies.get(
        'referralSuccess',
      ).referralUrl;
      this.frictionLess.referralCode = this.$cookies.get(
        'frictionLess',
      ).referralCode;
      this.frictionLess.receipientEmailIds = '';

      console.log(['Present', this.frictionLess, this.referralSuccess]);
    } else {
      this.referralSuccess = vxm.referrals.getReferralSuccess;
      this.frictionLess.referralCode = this.referralSuccess.referralCode;
      this.saveReferralData();
    }
    let referralUrl = this.referralSuccess.referralUrl
      ? this.referralSuccess.referralUrl
      : '';

      this.referralSuccess.referralUrl =   this.referralSuccess.referralUrl
    let n = referralUrl.lastIndexOf('referral');
    this.jobDetailsViewLink = referralUrl.substring(n, referralUrl.length);
  }

  saveReferralData() {
    this.$cookies.set(
      'referralSuccess',
      JSON.stringify(this.referralSuccess),
      300,
    );
    this.$cookies.set('frictionLess', JSON.stringify(this.frictionLess), 300);
  }

  sendReferralByEmail() {
    const vm = this;
    if (!vm.validateDataSendReferral(vm.frictionLess)) {
      vm.$wlToastr('error', vm.errorString, 'Referral');
    } else {
      const respPromise: any = vxm.referrals.postFrictionlessReferral(
        vm.frictionLess,
      );
      Promise.all([respPromise]).then((values) => {
        if (!values[0].success) {
          vm.$wlToastr('error', 'Unable to Send Email', 'Referral');
        } else {
          vm.$wlToastr('success', vm.$t('invite.email.success'), 'Referral');
          vm.frictionLess.receipientEmailIds = '';
          vxm.referrals.setGoogleContactResponse(new GoogleContactResponse());
        }
      });
    }
  }

  sendReferralByGoogle() {
    let mailString: string = '';
    this.selectedGoogleContacts.forEach((usr, idx) => {
      if (idx !== this.selectedGoogleContacts.length - 1) {
        mailString += usr.email + ',';
      } else {
        mailString += usr.email;
      }
    });
    this.frictionLess.receipientEmailIds = mailString;
    this.sendReferralByEmail();
  }

  validateDataSendReferral(frictionLess: Frictionless): boolean {
    if (!frictionLess.receipientEmailIds) {
      this.errorString = this.$t('referafriend.email.required').toString();
      return false;
    }
    return true;
  }

  handleSuccess(e) {
    console.log(e);
    this.$wlToastr('info', this.$t('referrals.copied'), 'Referral');
  }
  handleError(e) {
    console.log(e);
    this.$wlToastr('info', this.$t('referrals.unable.to.copy'), 'Referral');
  }
}
